import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const ChevronRight = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          ref={ref}
          {...props}
        >
          <path
            d="M6.10742 18L13.8912 10.2162L6.10742 2"
            stroke="currentcolor"
            strokeLinecap="square"
          />
        </svg>
      </Icon>
    );
  },
);

ChevronRight.displayName = "ChevronRight";
